// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import store from "./store";
import router from "./router";
import moment from "moment";
import fileDownload from "js-file-download";

import * as echarts from "echarts"; //引入echarts基础库
import "echarts-gl"; //引入echarts地图库
require("echarts/extension/bmap/bmap");

import $ from "jquery";
import layer from "layui-layer";
import fontawesome from "@fortawesome/fontawesome";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import solid from "@fortawesome/fontawesome-free-solid";
import regular from "@fortawesome/fontawesome-free-regular";
import brands from "@fortawesome/fontawesome-free-brands";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import BaiduMap from "vue-baidu-map";

//引入样式
import "@/assets/css/causeAnalyse.css";

fontawesome.library.add(solid);
fontawesome.library.add(regular);
fontawesome.library.add(brands);
Vue.use(ElementUI);
Vue.prototype.$moment = moment;
Vue.prototype.$fileDownload = fileDownload;

//定义全局挂载
Vue.prototype.$echarts = echarts;

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});

Vue.use(BaiduMap, {
  ak: "c6jaOdzlPwuqMKGCkiQgUfgVXwtdUvHZ" //天云网ak
});



// WEBPACK FOOTER //
// ./src/main.js